<div [hidden]="showSearch == true">
  <div class="input-group">
    <input [(ngModel)]="value" class="form-control" />
    <span class="input-group-btn">
      <button pButton type="button" class="btn btn-default" (click)="displaySearch()" icon="pi pi-search"></button>
      <button pButton type="button" class="btn btn-default" (click)="clearSelectedImage()" icon="pi pi-times-circle"></button>
      <img src="/assets/img/help.png" [title]="helpIconTitle" class="wc-help-icon" *ngIf="helpIconTitle" />
    </span>
  </div>
</div>

<p class="wc-is-top-margin">
  <img class="wc-image-selector-selected-image" [src]="imageSelectedSource" [hidden]="imageSelectedSource == ''" />
</p>

<p>
  <select class="form-control" [(ngModel)]="selectedImageTypeId" [hidden]="showSearch == false" (ngModelChange)="imageTypeChange($event)">
    <option
      *ngFor="let imageType of imageTypes"
      [value]="imageType.value"
      [selected]="imageType.value == selectedImageTypeId ? true : null"
    >
      {{
        imageType.name +
          (imageType.value == selectedImageTypeId ? ' (' + ('config.image-lookup.component.click-for-more-options' | translate) + ')' : '')
      }}
    </option>
  </select>
</p>

<div [hidden]="showSearch == false">
  <div [hidden]="selectedImageTypeId == 3">
    <div>
      <div class="input-group">
        <input class="form-control" [(ngModel)]="searchParams.FileName" *ngIf="showSearch == true" />
        <span class="input-group-btn">
          <button
            pButton
            type="button"
            class="btn btn-default"
            (click)="searchImages()"
            *ngIf="showSearch == true"
            icon="pi pi-search"
          ></button>
        </span>
      </div>
    </div>

    <p>
      <wl-busy [show]="isSearching"></wl-busy>
    </p>

    <div [hidden]="searchHasResults == false || isSearching == true">
      <div>
        <p-table
          [showGridlines]="true"
          scrollHeight="100%"
          scrollWidth="100%"
          [value]="imageSearchResult.Result"
          [rows]="10"
          [paginator]="true"
          [pageLinks]="3"
          [rowsPerPageOptions]="[5, 10, 20]"
          [lazy]="true"
          [totalRecords]="imageSearchResult.TotalCount"
          (onLazyLoad)="searchImages($event)"
        >
          <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
            <SortAltIcon *ngIf="sortOrder === 0">
              <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
            </SortAltIcon>
            <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
              <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
            </SortAmountUpAltIcon>
            <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
              <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
            </SortAmountDownIcon>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th [pSortableColumn]="'Title'">
                Image
                <p-sortIcon></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-image>
            <tr>
              <td>
                <div class="col-sm-6">
                  <span *ngIf="image.WebContentID > 0">
                    <img
                      [src]="getWebContentImageSourceUrl(image.WebContentID)"
                      [alt]="getWebContentImageSourceUrl(image.WebContentID)"
                      height="50"
                      width="50"
                    />
                  </span>
                  <span *ngIf="image.WebContentID <= 0">
                    <img
                      [src]="webServerBaseImageSourceUrl + '/' + image.Title"
                      [alt]="webServerBaseImageSourceUrl + '/' + image.Title"
                      height="50"
                      width="50"
                    />
                  </span>
                </div>
                <div class="col-sm-4">
                  <span>{{ image.Title }}</span>
                  <span *ngIf="image.WebContentID > 0"> &nbsp;(ContentId {{ image.WebContentID }}) </span>
                </div>
                <div class="col-sm-2">
                  <button type="button" class="atlas-btn atlas-btn-primary" (click)="selectImage(image)">
                    {{ 'common.select' | translate | uppercase }}
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <p-progressSpinner *ngIf="isSearching"></p-progressSpinner>
      </div>
    </div>
    <div [hidden]="searchHasResults == true || searchPerformed == false || isSearching == true">
      <h4>{{ 'common.phrases.no-results-found' | translate }}</h4>
    </div>
  </div>

  <div [hidden]="selectedImageTypeId != 3">
    <b>Image Upload</b>
    <div>
      <p-fileUpload
        #eventImageUpload
        name="File"
        accept="image/*"
        [url]="uploadImageUrl"
        (onUpload)="onUpload($event)"
        (onError)="onError($event)"
        [disabled]="eventImageUpload.hasFiles()"
      ></p-fileUpload>
    </div>
  </div>
</div>
